import axiosInstance from "../api/axiosInstance"

// GET: List users with pagination, filters, search
export const fetchPaymentsandTransactions = (params) => axiosInstance.get("/admin/iap/purchases", { params });

// Get purchase by ID (Admin view)
export const fetchPurchaseById = (id) => {
  return axiosInstance.get(`/admin/iap/purchase/${id}`);
};

export const fetchSubscriptions = (params) => {
  return axiosInstance.get("/admin/iap/subscriptions", { params });
};

export const fetchSubscriptionById = (id) =>
  axiosInstance.get(`/admin/iap/subscription/${id}`);

export const exportPurchases = (params) => {
  return axiosInstance.get("/admin/iap/purchases/export", {
    params,
    responseType: "blob",
  });
};


export const exportSubscriptions = (params) => {
  return axiosInstance.get("/admin/iap/subscriptions/export", {
    params,
    responseType: "blob",
  });
};

